//#region imports
import React, { useEffect, useState } from "react";

// bootstrap
import Row from "react-bootstrap/Row";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectEmployeeList, selectEmployeeFilter, selectEmployeeSearchTerm, } from "_redux/slices/timeline/employees";
import { selectSelectedTimeline } from "_redux/slices/timeline/timeline-areas";
import { selectCurrentPage, selectRowsPerPage, selectThirtyMinLayout, setCurrentRange, setPageCount } from "_redux/slices/timeline/timeline-control";

// components
import TimelineRow from "../timeline-components/timeline-row";
import TimelineThirtyMinRow from "../timeline-components/timeline-thirtyMin-row";

// styles
import { Colors } from "_styles";

// timeline constants
import { manualPaginate } from "_utils/functions";

//#endregion

// lists each employee row in timeline
const EmployeeList = React.memo((props) => {

  //#region redux
  const dispatch = useDispatch();

  // list + filter
  const employeeFilter = useSelector(selectEmployeeFilter);               // Filter for employee list
  const allEmployees = useSelector(selectEmployeeList);                   // List of all employees

  // search bar
  const selectedTimeline = useSelector(selectSelectedTimeline);           // Term entered in search bar
  const searchTerm = useSelector(selectEmployeeSearchTerm);               // Holds the value of the employee search bar

  // pagination
  const employeesPerPage = useSelector(selectRowsPerPage);                // Number employees per page
  const currentPage = useSelector(selectCurrentPage);                     // Employee pagination CurrentPage

  // 30 min layout
  const thirtyMinLayout = useSelector(selectThirtyMinLayout);             // True or false for 30 min layout
  //#endregion

  //#region local states
  const [employees, setEmployees] = useState([]);                         // handles list of employees locally (uses redux + pagination)
  //#endregion

  //#region useEffect

  useEffect(() => {
    // Paginate the full list of employees based on current page and rows per page
    let tempEmployees = manualPaginate(
      allEmployees,                                           // full list of employees      
      employeesPerPage ? employeesPerPage : 25,               // default to 25 if not set
      currentPage ? currentPage : 1,                         // default to 1 if not set
      employeeFilter,
    );

    dispatch(setPageCount(tempEmployees.pageCount));          // set page count in redux
    dispatch(setCurrentRange(tempEmployees.currentRange));    // set current range in redux (e.g., 1–25, 26–50)

    setEmployees(tempEmployees.requiredArr);                  // set the employee list in local state

  }, [employeeFilter, selectedTimeline, searchTerm, currentPage, allEmployees, employeesPerPage]);

  //#endregion

  // Return list of employees in timeline view
  return (
    <div>

      {/* check if employees is not empty */}
      {Array.isFullArray(employees) ? (thirtyMinLayout ?
        /* 30 min layout */
        <div>
          {employees.map((employee, index, employeeArray) => {
            // for each employee map their timeline row
            return (
              <TimelineThirtyMinRow
                index={index}
                key={employee.employeeId}
                clickedColumn={props?.clickedColumn}
                setClickedColumn={props?.setClickedColumn}
                employee={employee}
                arrayLength={employeeArray.length || 0}
              />
            );
          })}
        </div>
        :
        /* 1 hour layout */
        <div>
          {employees.map((employee, index, employeeArray) => {
            // for each employee map their timeline row
            return (
              <TimelineRow
                index={index}
                key={employee.employeeId}
                clickedColumn={props?.clickedColumn}
                setClickedColumn={props?.setClickedColumn}
                employee={employee}
                arrayLength={employeeArray.length || 0}
              />
            );
          })}
        </div>
      )
        :
        (
          // If no employees found, show nothing
          <Row style={{ opacity: 0.9 }} className="d-flex justify-content-center">

          </Row>
        )}
    </div>
  );

});

export default EmployeeList;
